import { Component, OnInit, Input, AfterViewInit, EventEmitter, Output } from '@angular/core';
import { EFormConfiguration } from '../../e-form-config.model';
import { EFormService } from '../../e-form.service';
import { Subscription } from 'rxjs';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { YearService } from '../../../year/year.service';
import { LoginService } from '../../../../shared-modules/login/login.service';
import { ReportingService } from '../../../../shared-modules/reporting/reporting.service';
import { UserService } from '../../../user/user.service';

@Component({
  selector: 'e-form-header',
  templateUrl: './e-form-header.component.html',
  styleUrls: ['./e-form-header.component.css']
})
export class EFormHeaderComponent implements OnInit, AfterViewInit {

  @Input() editable: boolean;
  @Input() disableMergeFields: boolean;
  @Input() print: boolean;
  @Input() showConditionals: boolean;
  @Input() masterId: number;
  @Input() designPageIndex: number;
  @Input() config: EFormConfiguration;
  @Output() viewInitialized: EventEmitter<boolean> = new EventEmitter<boolean>();

  districtLogo: SafeResourceUrl;
  siteLogo: SafeResourceUrl;
  alternateSiteLogo: SafeResourceUrl;
  alternateDistrictLogo: SafeResourceUrl;

  pipeTrigger = false;
  currentDate: Date = new Date();
  schoolNameTag: string = '<<Behavior School Name>>';
  schoolAddressTag: string = '<<Behavior School Address 1>>';
  schoolCityTag: string = '<<Behavior School City>>';
  schoolStateTag: string = '<<Behavior School State>>';
  schoolZipTag: string = '<<Behavior School Zip>>';
  schoolPhoneTag: string = '<<Behavior School Phone>>';
  studentNameTag: string = '<<Student name - full (first last)>>'
  parentNameTag: string = '<<Family parents combined mailing name>>';
  parentAddressStreetTag: string = '<<Family Address - Street Number, Name, Apt>>';
  parentAddressCityTag: string = '<<Family Address - City, State, Zip>>';
  initialized = false;
  subscriptions: Subscription[] = [];
  
  constructor(private eFormService: EFormService,
              private yearService: YearService,
              private loginService: LoginService,
              private reportingService: ReportingService,
              private userService: UserService,
              private sanitizer: DomSanitizer) { 

  }

  ngOnInit() {
    if(this.config.HeaderSelectedLogo != 0) {
      this.getLogos();
    }

    if (this.config.CalledFromAttendanceLetter == true) {
      this.schoolNameTag = '<<Attendance School Name>>';
      this.schoolAddressTag = '<<Attendance School Address 1>>';
      this.schoolCityTag = '<<Attendance School City>>';
      this.schoolStateTag = '<<Attendance School State>>';
      this.schoolZipTag = '<<Attendance School Zip>>';
      this.schoolPhoneTag = '<<Attendance School Phone>>';
    }
  }

  getLogos() {
    if(this.eFormService.districtLogo && this.eFormService.alternateDistrictLogo && this.eFormService.siteLogo && this.alternateSiteLogo) {

      this.districtLogo = this.eFormService.districtLogo;
      this.alternateDistrictLogo = this.eFormService.alternateDistrictLogo;
      this.siteLogo = this.eFormService.siteLogo;
      this.alternateSiteLogo = this.eFormService.alternateSiteLogo;
    }
    else {
      this.reportingService.getReportLogos(this.userService.currentUser.Id, this.yearService.defaultYear.SchoolID).subscribe(reportLogos => {
          this.districtLogo = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64, ' + this.loginService.LoginSettings.DistrictLogo.toString());
          this.alternateDistrictLogo = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64, ' + reportLogos['AlternateDistrictLogo']);
          this.siteLogo = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64, ' + reportLogos['SiteLogo']);
          this.alternateSiteLogo = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64, ' + reportLogos['AlternateSiteLogo']);
      });
    }
  }

  ngAfterViewInit() {
    this.viewInitialized.emit(true);
  }
}
